import { Controller } from "@hotwired/stimulus";

// This controller handles automatic form submission for filter forms
export default class extends Controller {
  static targets = ["form", "input", "select"];

  connect() {
    this.debouncedSubmit = this.debounce(this.submit.bind(this), 500);

    if (this.hasInputTarget) {
      this.inputTargets.forEach((input) => {
        input.addEventListener("input", this.debouncedSubmit);
      });
    }

    if (this.hasSelectTarget) {
      this.selectTargets.forEach((select) => {
        select.addEventListener("change", this.submit.bind(this));
      });
    }
  }

  disconnect() {
    if (this.hasInputTarget) {
      this.inputTargets.forEach((input) => {
        input.removeEventListener("input", this.debouncedSubmit);
      });
    }

    if (this.hasSelectTarget) {
      this.selectTargets.forEach((select) => {
        select.removeEventListener("change", this.submit.bind(this));
      });
    }
  }

  submit(event) {
    if (this.hasFormTarget) {
      this.formTarget.requestSubmit();
    } else if (this.element.tagName === "FORM") {
      this.element.requestSubmit();
    }
  }

  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  reset(event) {
    event.preventDefault();

    // Reset all form fields
    if (this.formTarget) {
      this.formTarget.reset();

      // Navigate to the base URL without params
      const turboFrame = document.getElementById("transactions-list");
      turboFrame.src = this.formTarget.action;
      turboFrame.reload();
    }
  }
}
